/* TBM understated scroll reveals and cart confirmation — no external dependencies. */
(function () {
  'use strict';

  function init() {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tbm-sober-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.06, rootMargin: '0px 0px 18px 0px' });

    function reveal(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      var selectors = ['#MainContent .title_section'];
      if (!mobile) selectors.push('#MainContent .grid-wrapper > .item');
      if (document.body.classList.contains('template-product')) {
        selectors.push('#MainContent .product-template__container .product-single__tab');
      }
      var els = scope.querySelectorAll(selectors.join(','));
      var productIndex = 0;
      els.forEach(function (el) {
        if (el.dataset.tbmSoberObserved) return;
        if (el.closest('.swiper-wrapper, .slick-track, [role="dialog"], .product__popup-swatch')) return;
        el.dataset.tbmSoberObserved = 'true';
        var rect = el.getBoundingClientRect();
        if (rect.height === 0 || rect.width === 0) return;
        /* Never conceal above-the-fold content or anything already visible. */
        if (rect.top < window.innerHeight + 22) return;
        var card = el.classList.contains('item');
        if (card) {
          el.style.setProperty('--tbm-motion-delay', String((productIndex++ % 4) * 45) + 'ms');
        }
        el.classList.add('tbm-sober-pending');
        observer.observe(el);
      });
    }

    reveal(document);
    document.addEventListener('shopify:section:load', function (evt) {
      reveal(evt.target || document);
    });

    /* Only a brief acknowledgement when the existing cart count increases.
       Never intercept cart submission, change quantities, or modify checkout. */
    var count = document.querySelector('.site-header .site-header__cart-count .CartCount');
    var icon = count && count.closest('.site-header__cart-icon');
    if (count && icon && 'MutationObserver' in window) {
      var last = parseInt(count.textContent, 10) || 0;
      new MutationObserver(function () {
        var current = parseInt(count.textContent, 10);
        if (!Number.isFinite(current)) return;
        if (current > last) {
          icon.classList.remove('tbm-cart-confirmation');
          /* Restart once per actual cart addition, never as a looping animation. */
          void icon.offsetWidth;
          icon.classList.add('tbm-cart-confirmation');
        }
        last = current;
      }).observe(count, { subtree: true, characterData: true, childList: true });
      icon.addEventListener('animationend', function () {
        icon.classList.remove('tbm-cart-confirmation');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
